<template>
  <main class="container my-2" style="max-width: 900px">
    <div class="mt-3">
      <SimuladorStep v-if="step" :step="step" :valor="plano.valorMensal"
        :periodicidade="plano.modeloCobranca.periodicidade">
      </SimuladorStep>

      <ul class="list-group text-muted px-3 ">
        <li class="
            list-group-item
            px-4
            d-flex
            justify-content-between
            align-items-center
          " style="border-top-width: 1px">

          <strong>
            <span> Selecione um cartão de crédito</span>
          </strong>
        </li>

        <li v-for="(cartao, index) in cartoes" :key="index" class="
            list-group-item
            px-4
            d-flex
            justify-content-between
            align-items-center
          " style="border-top-width: 1px">
          <div class="col text-left">
            <span class="ml-1">
              <input type="radio" name="cartaoSelecionado" :value="cartao" v-model="cartaoCobranca"
                id="flexRadioDefault1" />
            </span>
            <span class="ml-1">
              <strong>
                <span class="ml-2">
                  **** **** **** {{ cartao.ultimosDigitos.replace("(não verificado)", "") }}
                </span>
              </strong>
            </span>
          </div>
          <div class="col-2 text-rigth">
            <img :src="icons[cartao.bandeira]" alt="bandeira" width="36" />
          </div>
          <div class="col-2 text-rigth icon">
            <a class="btn" @click="excluirCartao(cartao)">
              <i class="fa-solid fa-trash-can"></i>
            </a>
          </div>
        </li>

      </ul>

    </div>

    <div v-if="erro" class="card my-2 badge-danger text-center p-3 text-uppercase m-3">
      {{ erro.title }}
    </div>

    <div class="mt-3 mb-5 px-3 col-12 d-flex flex-column flex-lg-row justify-content-between">
      <button class="btn btn_color_system px-5 mt-4 py-2" @click="$router.go(-1)">
        VOLTAR
      </button>
      <button class="btn btn_color_system py-2 px-5 mt-4" type="button" @click="adicionarCartao" data-bs-toggle="modal"
        data-bs-target="#exampleModal">
        NOVO CARTÃO
      </button>
      <button class="btn btn_color_system py-2 px-5 mt-4" type="button" @click="selecionaMeioPagamento(cartaoCobranca)">
        CONTRATAR
      </button>
    </div>

    <div class="row d-flex assinar-plano fixed-bottom text-center" v-if="!step">
      <div class="col-12 m-2 text-center">
        <small> <strong>Valor do plano</strong></small> <br />
        <span class="valor-plano">R$ {{ formatPrice(plano.valorMensal) }}
          /{{ plano.modeloCobranca.periodicidade }}</span>
        <br />
      </div>
    </div>

    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-cartao-full">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Cartão de crédito</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">X</button>
          </div>
          <div class="modal-body">
            <iframe :src="urlFormCartao" class="modal-cartao-body-full"></iframe>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" id="fecharModal" data-bs-dismiss="modal">Cancelar</button>
          </div>
        </div>
      </div>
    </div>
    <Loading v-if="loading"></Loading>
  </main>
</template>

<script>
import Loading from "@/components/Loading.vue";
import SimuladorStep from "@/components/assinaturas/SimuladorStep.vue";
import icons from "@/shared/components/SvgIcon.js";
import { APIService } from "../../APIService";
const apiService = new APIService();

export default {
  name: "StepPagamento",
  components: { Loading, SimuladorStep },
  props: ["idAssinatura", "idPlanoAssinatura", "modeloCobranca"],
  data() {
    return {
      icons,
      pagamento: { valor: null },
      carteira: {},
      cartoes: [],
      cartaoCobranca: null,
      carrinho: { id: null },
      loading: true,
      urlFormCartao: "",
      cartaoForm: false,
      pagamentoComCartao: false,
      intervalFetchStatusCartao: null,
      contVerificacaoCartao: 0,
      boleto: null,
      detail: null,
      planoId: null,
      assinaturaId: null,
      erro: null,
      plano: this.$store.state.simulacaoPlano,
      step: this.$route.query.step

    };
  },
  mounted() {
    this.loading = true;

    const _plano = localStorage.getItem("simulacao-plano");
    if (_plano) {
      this.plano = JSON.parse(_plano);
    }

    if (!this.idAssinatura) {
      this.planoId = this.$route.params.planoId;
    } else {
      this.planoId = this.idAssinatura;
    }
    if (!this.idPlanoAssinatura) {
      this.assinaturaId = this.$route.params.assinaturaId;
    } else {
      this.assinaturaId = this.idPlanoAssinatura;
    }

    if (
      this.modeloCobranca &&
      this.modeloCobranca.formaPagamento === "BOLETO"
    ) {
      apiService
        .obterBoletoPagamentoRecorrente(this.assinaturaId)
        .then((res) => {
          this.boleto = res;
          this.loading = false;
        }).catch((error) => {
          this.erro = error.response.data;
        })
        .finally(() => (this.loading = false));
    } else if (
      this.modeloCobranca &&
      this.modeloCobranca.formaPagamento === "CARTEIRA_DIGITAL"
    ) {
      apiService.getCarteira().then((res) => {
        this.carteira = res;
      }).catch((error) => {
        this.erro = error.response.data;
      })
        .finally(() => (this.loading = false));
    } else {
      this.getListaCartoes();
    }

    this.loading = true;
    apiService
      .obterDetalhePagamentoRecorrente(this.assinaturaId)
      .then((response) => {
        this.loading = false;
        this.detail = response;
      }).catch((error) => {
        this.erro = error.response.data;
      })
      .finally(() => (this.loading = false));
  },
  methods: {
    excluirCartao(cartao) {
      this.$swal({
        title: "Tem certeza de que quer excluir o cartão?",
        html: `<div class="pt-3"> **** **** **** ${cartao.ultimosDigitos.replace("(não verificado)", "")}</div><small>${cartao.bandeira}</small>`,
        confirmButtonText: "Excluir",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        preConfirm: () => {
          this.loading = true;
          apiService.removerCartao(cartao.codigoCartao).then(() => {
            apiService.getListaCartoes().then((resCartao) => {
              this.cartoes = resCartao;
              this.$swal({
                title: "Cartão removido com sucesso",
                confirmButtonText: "Fechar",
              });
            });
          }).catch((error) => {
            this.erro = error.response.data;
          })
            .finally(() => (this.loading = false));
        },
      });
    },
    getListaCartoes() {
      this.loading = true;
      apiService.getListaCartoes().then((res) => {
        this.cartoes = res;
      }).catch((error) => {
        this.erro = error.response.data;
      })
        .finally(() => (this.loading = false));
    },
    selecionaMeioPagamento(item) {
      if (item) {
        this.loading = true;
        apiService
          .selecionaMeioPagamento(this.assinaturaId, item)
          .then(res => {
            if (res.statusBoolean) {
              this.aceitarPagamento();
            }
          }).catch((error) => {
            this.erro = error.response.data;
            this.loading = false;
          })
      } else {
        this.erro = { title: 'Selecione um cartão de crédito.' }
      }
    },
    aceitarPagamento() {
      this.loading = true;
      apiService
        .aceitarPagamento(this.detail)
        .then(() => {
          if (window.PIXEL_CODE) {
            window.fbq("track", "Purchase", {
              value: this.detail.valorParcela,
              currency: "BRL",
              predicted_ltv: "0.00",
              content_name: this.detail.nome,
            });
          }

          this.$swal({
            title: "Parabéns!!!",
            text: "Sua assinatura foi criada com sucesso. Aproveite seus benefícios!!",
            confirmButtonText: "Ok",
          });

          this.$router.push(`/assinaturas`);
        }).catch((error) => {
          this.erro = error.response.data;
        })
        .finally(() => (this.loading = false));
    },
    adicionarCartao() {
      this.loading = true;
      apiService
        .cadastrarCartao({ cartaoOrigem: "RECORRENCIA" })
        .then((res) => {
          this.urlFormCartao = res.url;
          this.loading = false;
          clearInterval(this.intervalFetchStatusCartao);
          this.VerificarCartao(res.codigoCartao);
          if (window.PIXEL_CODE) {
            window.fbq("track", "AddPaymentInfo");
          }
        });
    },
    VerificarCartao(codigoCartao) {
      this.intervalFetchStatusCartao = setInterval(() => {
        apiService
          .cartaoConta(codigoCartao)
          .then((res) => {
            if (res.ativo) {
              this.toggleCartaoForm();
              clearInterval(this.intervalFetchStatusCartao);
              this.contVerificacaoCartao = 0;
            } else {
              if (this.contVerificacaoCartao < 20) {
                this.contVerificacaoCartao = this.contVerificacaoCartao + 1;
              } else {
                clearInterval(this.intervalFetchStatusCartao);
                this.contVerificacaoCartao = 0;
              }
            }
          })
          .catch(() => {
            if (this.contVerificacaoCartao < 20) {
              this.contVerificacaoCartao = this.contVerificacaoCartao + 1;
            } else {
              clearInterval(this.intervalFetchStatusCartao);
              this.contVerificacaoCartao = 0;
            }
          });
      }, 5000);
    },
    beforeUnmount() {
      clearInterval(this.intervalFetchStatusCartao);
    },
    toggleCartaoForm() {
      document.getElementById('fecharModal').click();
      this.getListaCartoes();
    },
    formatPrice(value) {
      let val = ((value || 0) / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    goToStep(step) {
      this.$emit("goToStep", step);
    }
  }
};
</script>
<style scoped lang="scss">
.pagamentoCartao {
  position: relative;
  height: 600px;
}

.icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  transition: 0.5s;
  color: var(--cor-secundaria);
  overflow: hidden;
}

.modal-cartao-full {
  max-width: 52.5vh;
}

.modal-cartao-body-full {
  overflow: auto;
  min-height: 82.5vh;
  max-height: 82.5vh;
  width: 100%;
  border: 0;
}

.endereco {
  position: absolute;
  top: -46px;
  left: 0;
  background-color: #f2f2f2;
  width: 100%;
  height: 685px;
  overflow: auto;
  z-index: 2;
}
</style>
